import { SIZES } from './enums';
import { ComponentSize, IconSize } from './types';

export const Sizes = {
  xxSmall: {
    height: SIZES.EXTRA_EXTRA_SMALL_HEIGHT,
    width: SIZES.EXTRA_EXTRA_SMALL_WIDTH,
  },

  extraSmall: {
    height: SIZES.EXTRA_SMALL_HEIGHT,
    width: SIZES.EXTRA_SMALL_WIDTH,
  },

  small: {
    height: SIZES.SMALL_HEIGHT,
    width: SIZES.SMALL_WIDTH,
  },

  medium: {
    height: SIZES.MEDIUM_HEIGHT,
    width: SIZES.MEDIUM_WIDTH,
  },

  large: {
    height: SIZES.LARGE_HEIGHT,
    width: SIZES.LARGE_WIDTH,
  },
  extraLarge: {
    height: SIZES.EXTRA_LARGE_HEIGHT,
    width: SIZES.EXTRA_LARGE_WIDTH,
  },
};

const getIconSize = (size: ComponentSize): IconSize => Sizes[size];

export default getIconSize;
